
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/Rx';

interface Response {
  data     : any;
}

@Injectable()
export class ChkService {

   constructor( private http: HttpClient) { }

   /*
    * Get the content of home page.
    */
   getHomeContent()
   {
      return this.http.get<Response>("assets/data/home.json").pipe(map(response => response.data));
   }

   /*
    * Get services
    */
   getServices()
   {
     return this.http.get<Response>("assets/data/service.json").pipe(map(response => response.data));
   }
   /*
    * Get Our services page items
    */
   getOurServices()
   {
     return this.http.get<Response>("assets/data/our-services-page.json").pipe(map(response => response.data));
   }


   /*
    * Get posts
    */
   getPosts()
   {
      return this.http.get<Response>("assets/data/posts.json").pipe(map(response => response.data));
   }

   /*
    * Get project gallary
    */
   getProjectGallary()
   {
      return this.http.get<Response>("assets/data/project-gallary.json").pipe(map(response => response.data));
   }


   /*
    * Get blog column2.
    */
   getBlogColumn2()
   {
      return this.http.get<Response>("assets/data/blog-column2.json").pipe(map(response => response.data));
   }

   /*
    * Get blog column3.
    */
   getBlogColumn3()
   {
      return this.http.get<Response>("assets/data/blog-column3.json").pipe(map(response => response.data));
   }

   /*
    * Get blog listing sidebar.
    */
   getBlogListingSideBar()
   {
      return this.http.get<Response>("assets/data/blog-listing-sidebar.json").pipe(map(response => response.data));
   }


   /*
    * Get blog masonary2
    */
   getBlogMasonary2()
   {
      return this.http.get<Response>("assets/data/blog-masonary2.json").pipe(map(response => response.data));
   }

   /*
    * Get blog masonary3
    */
   getBlogMasonary3()
   {
      return this.http.get<Response>("assets/data/blog-masonary3.json").pipe(map(response => response.data));
   }

   /*
    * Get blog no sidebar
    */
   getBlogNoSideBar()
   {
      return this.http.get<Response>("assets/data/blog-no-sidebar.json").pipe(map(response => response.data));
   }

   /*
    * Get blog sidebar
    */
   getBlogSidebar()
   {
      return this.http.get<Response>("assets/data/blog-sidebar.json").pipe(map(response => response.data));
   }

   /*
    * Get blog sidebar
    */
   getPopularPosts()
   {
      return this.http.get<Response>("assets/data/popular-posts.json").pipe(map(response => response.data));
   }

   /*
    * Get instagram images
    */
   getInstagramImages()
   {
      return this.http.get<Response>("assets/data/instagram.json").pipe(map(response => response.data));
   }

   /*
    * Get featured post
    */
   getFeaturedPost()
   {
      return this.http.get<Response>("assets/data/featured.json").pipe(map(response => response.data));
   }


   /*
    * Get Business Process Management Data
    */
   getBPMData()
   {
      return this.http.get<Response>("assets/data/bpm.json").pipe(map(response => response.data));
   }


   /*
    * Get testimonial
    */
   getTestimonial()
   {
      return this.http.get<Response>("assets/data/testimonial.json").pipe(map(response => response.data));
   }

   /*
    * Get portfolio-v1.
    */
   getPortfolioV1()
   {
    return this.http.get<Response>("assets/data/portfolio-v1.json").pipe(map(response => response.data));
   }

   /*
    * Get portfolio-v2.
    */
   getPortfolioV2()
   {
      return this.http.get<Response>("assets/data/portfolio-v2.json").pipe(map(response => response.data));
   }

   /*
    * Get portfolio-v3.
    */
   getPortfolioV3()
   {
      return this.http.get<Response>("assets/data/portfolio-v3.json").pipe(map(response => response.data));
   }
   /*
    * Get springboot portfolio.
    */
   getSpringbootPortfolio()
   {
      return this.http.get<Response>("assets/data/springbootportfolio.json").pipe(map(response => response.data));
   }
   /*
    * Get webapplications data
    */
   getWebAppData()
   {
      return this.http.get<Response>("assets/data/webapplications-data.json").pipe(map(response => response.data));
   }
   /*
    * Get artificial intelligence data
    */
   getAIData()
   {
      return this.http.get<Response>("assets/data/artificialIntelligence-data.json").pipe(map(response => response.data));
   }
    /*
    * Get artificial intelligence data
    */
    getBigData()
    {
       return this.http.get<Response>("assets/data/big-data.json").pipe(map(response => response.data));
    }
   /*
    * Get mobile data.
    */
   getMobileData()
   {
      return this.http.get<Response>("assets/data/mobile-data.json").pipe(map(response => response.data));
   }
   /*
    * Get erp data.
    */
   getERPData()
   {
      return this.http.get<Response>("assets/data/erp-data.json").pipe(map(response => response.data));
   }
   /*
    * Get virtual cto data.
    */
   getVirtualCTOData()
   {
      return this.http.get<Response>("assets/data/virtualCTO-data.json").pipe(map(response => response.data));
   }
   /*
    * Get temenos data.
    */
   getTemenosData()
   {
      return this.http.get<Response>("assets/data/temenos-data.json").pipe(map(response => response.data));
   }
   /*
    * Get sap-hana data.
    */
   getSapHanaData()
   {
      return this.http.get<Response>("assets/data/sap-hana-data.json").pipe(map(response => response.data));
   }

   /*
    * Get power BI data.
    */
   getPowerBIData()
   {
      return this.http.get<Response>("assets/data/power-bi-data.json").pipe(map(response => response.data));
   }
   /*
    * Get power BI data.
    */
   getDigitalMData()
   {
      return this.http.get<Response>("assets/data/digital-marketing-data.json").pipe(map(response => response.data));
   }
   /*
   * Get the content of pricing page.
   */
   getPricingPageContent()
   {
    return this.http.get<Response>("assets/data/pricing.json").pipe(map(response => response.data));
   }


   /*
   * Get the content of features page.
   */
   getFeaturesContent()
   {
    return this.http.get<Response>("assets/data/features.json").pipe(map(response => response.data));
   }

   /*
   * Get the content of features page.
   */
  getSpringBootContent()
  {
   return this.http.get<Response>("assets/data/spring-boot-features.json").pipe(map(response => response.data));
  }

  /*
      Get Manufacturing ERP Data
  */
   getManufacturingERPContent()
   {
   return this.http.get<Response>("assets/data/manufacturingerp.json").pipe(map(response => response.data));
   }

   /*
      Get Gsuite Data
   */
   getGsuiteContent()
   {
   return this.http.get<Response>("assets/data/gsuite-data.json").pipe(map(response => response.data));
   }

   /*
      Get Gsuite Data
   */
   getLearningMgmtContent()
   {
   return this.http.get<Response>("assets/data/learningmgmt-data.json").pipe(map(response => response.data));
   }

   /*
      Get Ecommerce Data
   */
  getEcommerceContent()
  {
  return this.http.get<Response>("assets/data/ecommerce-platform-data.json").pipe(map(response => response.data));
  }

  getSportsContent(){
   return this.http.get<Response>("assets/data/sportsERP.json").pipe(map(response => response.data));
   }

   /*
      Get Product Engineering Data
   */
   getProductEnggData(){
      return this.http.get<Response>("assets/data/product-engineering-data.json").pipe(map(response => response.data));
   }

   /*
   * Get the categories.
   */
   getcategories()
   {
    return this.http.get<Response>("assets/data/categories.json").pipe(map(response => response.data));
   }

   /*
   * Get the content of contact page.
   */
   getContactContent()
   {
    return this.http.get<Response>("assets/data/contact.json").pipe(map(response => response.data));
   }

   /*
   * Get the content of search page.
   */
   getSearchContent()
   {
    return this.http.get<Response>("assets/data/search.json").pipe(map(response => response.data));
   }

   /*
   * Get the team.
   */
   getTeam()
   {
      return this.http.get<Response>("assets/data/team.json").pipe(map(response => response.data));
   }

   /*
    * Get about.
    */
   getAbout()
   {
      return this.http.get<Response>("assets/data/about.json").pipe(map(response => response.data));
   }

   /*
   * Get the content of support page.
   */
   getSupportContent()
   {
    return this.http.get<Response>("assets/data/support.json").pipe(map(response => response.data));
   }

   /*
    * Get home testimonial
    */
   getHomeTestimonial()
   {
      return this.http.get<Response>("assets/data/home-testimonial.json").pipe(map(response => response.data));
   }

   /*
    * Get footer logo list
    */
   getFooterLogoList()
   {
      return this.http.get<Response>("assets/data/footer-logo.json").pipe(map(response => response.data));
   }

  /*
   * Get the social share list
   */
   getSocialShare()
   {
    return this.http.get<Response>("assets/data/social-share.json").pipe(map(response => response.data));
   }

  /*
   * Get the recent comments
   */
   getRecentComments()
   {
    return this.http.get<Response>("assets/data/recent-comments.json").pipe(map(response => response.data));
   }

   /*
    * Get contact us widgets
    */
   getContactUsWidgets()
   {
      return this.http.get<Response>("assets/data/contact-us-widgets.json").pipe(map(response => response.data));
   }

   /*
    * Get cart
    */
   getCart()
   {
      return this.http.get<Response>("assets/data/cart.json").pipe(map(response => response.data));
   }

   /*
    * Get tweets
    */
   getTweets()
   {
      return this.http.get<Response>("assets/data/latest-tweets.json").pipe(map(response => response.data));
   }

   /*
    * Get tags
    */
   getTags()
   {
      return this.http.get<Response>("assets/data/tags.json").pipe(map(response => response.data));
   }

   /*
    * Get archive
    */
   getArchive()
   {
      return this.http.get<Response>("assets/data/archive.json").pipe(map(response => response.data));
   }

   /*
    * Get about the author
    */
   getAboutAuthor()
   {
      return this.http.get<Response>("assets/data/about-author.json").pipe(map(response => response.data));
   }

   /*
    * Get about the author
    */
   getTabContent()
   {
      return this.http.get<Response>("assets/data/tab-content.json").pipe(map(response => response.data));
   }

   /*
    * Get products list
    */
   getProductsList()
   {
      return this.http.get<Response>("assets/data/products-list.json").pipe(map(response => response.data));
   }

   /*
    * Get related products list
    */
   getRelatedProducts()
   {
      return this.http.get<Response>("assets/data/related-products.json").pipe(map(response => response.data));
   }

}
